"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typings_1 = require("../typings");
var RECORDS_IN_REQUEST = 42;
var MAX_DATA_LENGTH_FOR_CHROME = 60000;
var Sender = (function () {
    function Sender(_a) {
        var hrefPrefix = _a.hrefPrefix, hrefPostfix = _a.hrefPostfix;
        this.events = [];
        this.waitTime = 100;
        this.hrefPrefix = hrefPrefix;
        this.hrefPostfix = hrefPostfix;
    }
    Sender.prototype.clientAction = function (actionInfo, listener) {
        var eventType = actionInfo.eventData.event;
        if (eventType === typings_1.BaobabLogEventType.Click)
            this.click(actionInfo, listener);
        else if (eventType === typings_1.BaobabLogEventType.Scroll)
            this.scroll(actionInfo, listener);
        else if (eventType === typings_1.BaobabLogEventType.Tech)
            this.tech(actionInfo, listener);
        else
            throw new Error("\u041D\u0435\u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u043C\u044B\u0439 \u0442\u0438\u043F \u0441\u043E\u0431\u044B\u0442\u0438\u044F \u0432 \u0411\u0430\u043E\u0431\u0430\u0431: " + eventType);
    };
    Sender.prototype.click = function (_a, listener) {
        var node = _a.node, eventData = _a.eventData;
        this.logEvent({
            event: typings_1.BaobabLogEventType.Click,
            service: eventData.service,
            subservice: eventData.subservice,
            'event-id': eventData.id,
            id: node.id,
            cts: eventData.cts,
            data: eventData.data,
            behaviour: eventData.behaviour,
        }, listener);
    };
    Sender.prototype.scroll = function (_a, listener) {
        var node = _a.node, eventData = _a.eventData;
        this.logEvent({
            event: typings_1.BaobabLogEventType.Scroll,
            service: eventData.service,
            subservice: eventData.subservice,
            'event-id': eventData.id,
            id: node.id,
            cts: eventData.cts,
            data: eventData.data,
        }, listener);
    };
    Sender.prototype.tech = function (_a, listener) {
        var node = _a.node, eventData = _a.eventData;
        this.logEvent({
            event: typings_1.BaobabLogEventType.Tech,
            service: eventData.service,
            subservice: eventData.subservice,
            type: eventData.type,
            'event-id': eventData.id,
            id: node.id,
            cts: eventData.cts,
            data: eventData.data,
        }, listener);
    };
    Sender.prototype.appendTree = function (_a, listener) {
        var node = _a.node, eventData = _a.eventData;
        this.logShowEvent({
            event: typings_1.BaobabLogEventType.Append,
            tree: node,
            cts: eventData.cts,
            'trigger-event-id': eventData.triggerEvent ? eventData.triggerEvent.id : null,
            'trigger-event-trusted': eventData.triggerEventTrusted,
        }, listener);
    };
    Sender.prototype.createTree = function (_a, listener) {
        var node = _a.node, eventData = _a.eventData;
        this.logShowEvent({
            event: typings_1.BaobabLogEventType.Create,
            tree: node,
            cts: eventData.cts,
            'trigger-event-id': eventData.triggerEvent ? eventData.triggerEvent.id : null,
            'trigger-event-trusted': eventData.triggerEventTrusted,
        }, listener);
    };
    Sender.prototype.detachTree = function (_a, listener) {
        var node = _a.node, eventData = _a.eventData;
        var data = {
            event: typings_1.BaobabLogEventType.Visibility,
            type: typings_1.VisibilityChangeType.Hide,
            'block-id': node.id,
            cts: eventData.cts,
            'trigger-event-id': eventData.triggerEvent ? eventData.triggerEvent.id : null,
            'trigger-event-trusted': eventData.triggerEventTrusted,
        };
        this.logEvent(data, listener);
    };
    Sender.prototype.attachTree = function (_a, listener) {
        var node = _a.node, eventData = _a.eventData;
        var data = {
            event: typings_1.BaobabLogEventType.Visibility,
            type: typings_1.VisibilityChangeType.Show,
            'block-id': node.id,
            cts: eventData.cts,
            'trigger-event-id': eventData.triggerEvent ? eventData.triggerEvent.id : null,
            'trigger-event-trusted': eventData.triggerEventTrusted,
        };
        this.logEvent(data, listener);
    };
    Sender.prototype.logEvent = function (data, listener) {
        var _this = this;
        this.events.push({ data: data, listener: listener });
        if (this.timerId)
            clearTimeout(this.timerId);
        this.timerId = setTimeout(function () { return _this.sendData(); }, this.waitTime);
    };
    Sender.prototype.logShowEvent = function (data, listener) {
        this.sendByAjax([{ data: data, listener: listener }]);
    };
    Sender.prototype.sendData = function () {
        var _this = this;
        for (var i = 0; i < this.events.length; i += RECORDS_IN_REQUEST) {
            var events = this.events.slice(i, i + RECORDS_IN_REQUEST);
            var eventRecords = events.map(function (event) { return '/events=' + encodeURIComponent(JSON.stringify([event.data])) + _this.hrefPostfix; });
            var sendStringData = eventRecords.join('\r\n');
            var isTooLongForChrome = sendStringData.length > MAX_DATA_LENGTH_FOR_CHROME;
            var isChrome = navigator.userAgent.indexOf('Chrome') !== -1;
            if (isChrome && isTooLongForChrome) {
                this.sendByAjax(events);
            }
            else if (!this.sendBySendBeacon(events)) {
                this.sendByImg(events);
            }
        }
        this.events = [];
    };
    Sender.prototype.sendBySendBeacon = function (events) {
        var _this = this;
        if (!navigator.sendBeacon)
            return false;
        var sendStringData = this.getEventRecords(events).join('\r\n');
        if (navigator.sendBeacon(this.hrefPrefix, sendStringData)) {
            events.forEach(function (event) { return _this.eventSend(event, {
                way: typings_1.BaobabSendWay.SendBeacon,
                sentContentLength: sendStringData.length,
                success: true,
            }); });
            return true;
        }
        return false;
    };
    Sender.prototype.sendByImg = function (events) {
        var _this = this;
        var eventRecords = this.getEventRecords(events);
        eventRecords.forEach(function (eventRecord, i) {
            var image = document.createElement('img');
            var sendData = _this.hrefPrefix + eventRecord;
            image.addEventListener('load', function () { return _this.eventSend(events[i], {
                way: typings_1.BaobabSendWay.Img,
                sentContentLength: sendData.length,
                success: true,
            }); });
            image.addEventListener('error', function () { return _this.eventSend(events[i], {
                way: typings_1.BaobabSendWay.Img,
                sentContentLength: sendData.length,
                success: false,
            }); });
            image.src = sendData;
        });
        return true;
    };
    Sender.prototype.sendByAjax = function (events) {
        var _this = this;
        var eventRecords = this.getEventRecords(events);
        var sendStringData = eventRecords.join('\r\n');
        var sender = new XMLHttpRequest();
        sender.addEventListener('readystatechange', function () {
            if (sender.readyState !== XMLHttpRequest.DONE)
                return;
            events.forEach(function (event) { return _this.eventSend(event, {
                way: typings_1.BaobabSendWay.Ajax,
                success: sender.status === 200,
                sentContentLength: sendStringData.length,
                status: sender.status,
                xmlHttpRequest: sender,
            }); });
        });
        sender.open('POST', this.hrefPrefix);
        sender.send(sendStringData);
        return true;
    };
    Sender.prototype.getEventRecords = function (events) {
        var _this = this;
        return events.map(function (event) { return '/events=' + encodeURIComponent(JSON.stringify([event.data])) + _this.hrefPostfix; });
    };
    Sender.prototype.eventSend = function (event, sendInfo) {
        event.listener && event.listener({ eventData: event.data, sendInfo: sendInfo });
    };
    return Sender;
}());
exports.Sender = Sender;
